import { useQuasar } from 'quasar'

export function useDialog () {
  const $q = useQuasar()

  function open (opt) {
    return $q.dialog(Object.assign({
      html: true,
      class: 'app-dialog',
      cancel: {
        outline: true,
        color: 'secondary',
        unelevated: true
      },
      ok: {
        fill: true,
        color: 'secondary',
        unelevated: true
      },
      persistent: true
    }, opt))
  }

  return {
    open
  }
}
